import * as tslib_1 from "tslib";
import { Store, StoreConfig } from '@datorama/akita';
export function createSessionInitialState() {
    return {
        loading: false,
        token: null,
        user: null
    };
}
var SessionStore = /** @class */ (function (_super) {
    tslib_1.__extends(SessionStore, _super);
    function SessionStore() {
        return _super.call(this, createSessionInitialState()) || this;
    }
    SessionStore = tslib_1.__decorate([
        StoreConfig({ name: 'session' }),
        tslib_1.__metadata("design:paramtypes", [])
    ], SessionStore);
    return SessionStore;
}(Store));
export { SessionStore };
